<template>
  <div>
    <img class="squirkle avatar" :src="userAvatar" alt />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UserAvatar",
  components: {},
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    getUser() {
      return this.user ? this.user : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
    userAvatar() {
      if (this.user) {
        if (this.userData) {
          if (this.userData.gender) {
            if (this.userData.gender === "Male") {
              return require("../assets/img/avatar_m.png");
            } else if (this.userData.gender === "Female") {
              return require("../assets/img/avatar_f.png");
            }
          }
        }
        return require("../assets/img/avatar.png");
      } else {
        return require("../assets/img/avatar.png");
      }
    }
  },
  data() {
    return {};
  },
  mounted: function() {}
};
</script>
